module.exports = __webpack_public_path__ + "fonts/36dff93.ttf";